<template>
  <simple-card-dialog
    v-model="model"
    :title="$t('User.Creation.CreateUsers')"
    width="90%"
    class="wide-dialog"
    :disable-submit="hasEditingRows"
  >
    <!-- Instructions Steps Card -->
    <v-card
      flat
      class="instructions-card mb-4"
      color="info-background"
    >
      <v-card-text>
        <div class="steps-container">
          <!-- Step 1 -->
          <div class="step" :class="{ 'active': activeStep === 1 }">
            <div class="step-number">
              1
            </div>
            <div class="step-content">
              <div class="step-title">
                {{ $t('User.Creation.Steps.DownloadTemplate') }}
              </div>
              <div class="step-description">
                {{ $t('User.Creation.Steps.DownloadTemplateDesc') }}
              </div>
            </div>
          </div>
          <v-divider vertical class="step-divider" />
          <!-- Step 2 -->
          <div class="step" :class="{ 'active': activeStep === 2 }">
            <div class="step-number">
              2
            </div>
            <div class="step-content">
              <div class="step-title">
                {{ $t('User.Creation.Steps.FillTemplate') }}
              </div>
              <div class="step-description">
                {{ $t('User.Creation.Steps.FillTemplateDesc') }}
              </div>
            </div>
          </div>
          <v-divider vertical class="step-divider" />
          <!-- Step 3 -->
          <div class="step" :class="{ 'active': activeStep === 3 }">
            <div class="step-number">
              3
            </div>
            <div class="step-content">
              <div class="step-title">
                {{ $t('User.Creation.Steps.UploadAndSubmit') }}
              </div>
              <div class="step-description">
                {{ $t('User.Creation.Steps.UploadAndSubmitDesc') }}
              </div>
            </div>
          </div>
          <v-divider vertical class="step-divider" />
          <!-- info -->
          <div class="step">
            <div class="step-number">
              4
            </div>
            <div class="step-content">
              <div class="step-title">
                {{ $t('User.Creation.Steps.UserGroupsAndService') }}
              </div>
              <div class="step-description">
                <code>{{ $t('User.Creation.Steps.UserGroupsAndServiceDesc') }}</code>
              </div>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>

    <!-- Help button and requirements section -->
    <div class="helper-prompt">
      <v-btn
        color="info"
        variant="tonal"
        prepend-icon="mdi-help-circle-outline"
        class="helper-button"
        @click="showHelperDialog = true"
      >
        {{ $t('User.Creation.ViewFieldRequirements') }}
      </v-btn>
      <span class="helper-text">{{ $t('User.Creation.ViewRequirementsHint') }}</span>
    </div>

    <!-- Help Card - Displayed after file upload -->
    <!-- 画面内での編集不可とする -->
    <!--    <v-card-->
    <!--      v-if="isFileLoaded"-->
    <!--      flat-->
    <!--      class="help-card mb-4"-->
    <!--      color="success-background"-->
    <!--    >-->
    <!--      <v-card-text>-->
    <!--        <div class="help-title">-->
    <!--          <v-icon icon="mdi-lightbulb-outline" color="success" class="me-2" />-->
    <!--          {{ $t('User.Creation.Help.Title') }}-->
    <!--        </div>-->
    <!--        <div class="help-actions">-->
    <!--          &lt;!&ndash; Edit action &ndash;&gt;-->
    <!--          <div class="help-action">-->
    <!--            <v-icon-->
    <!--              icon="mdi-pencil"-->
    <!--              size="small"-->
    <!--              color="success"-->
    <!--              class="me-2"-->
    <!--            />-->
    <!--            <span>{{ $t('User.Creation.Help.EditAction') }}</span>-->
    <!--          </div>-->
    <!--          &lt;!&ndash; Double click action to edit &ndash;&gt;-->
    <!--          <div class="help-action">-->
    <!--            <v-icon-->
    <!--              icon="mdi-click"-->
    <!--              size="small"-->
    <!--              color="success"-->
    <!--              class="me-2"-->
    <!--            />-->
    <!--            <span>{{ $t('User.Creation.Help.DoubleClickAction') }}</span>-->
    <!--          </div>-->
    <!--          &lt;!&ndash; Save action &ndash;&gt;-->
    <!--          <div class="help-action">-->
    <!--            <v-icon-->
    <!--              icon="mdi-content-save"-->
    <!--              size="small"-->
    <!--              color="success"-->
    <!--              class="me-2"-->
    <!--            />-->
    <!--            <span>{{ $t('User.Creation.Help.SaveAction') }}</span>-->
    <!--          </div>-->
    <!--          &lt;!&ndash; Double click action to save &ndash;&gt;-->
    <!--          <div class="help-action">-->
    <!--            <v-icon-->
    <!--              icon="mdi-click"-->
    <!--              size="small"-->
    <!--              color="success"-->
    <!--              class="me-2"-->
    <!--            />-->
    <!--            <span>{{ $t('User.Creation.Help.DoubleClickSaveAction') }}</span>-->
    <!--          </div>-->
    <!--          &lt;!&ndash; Undo action &ndash;&gt;-->
    <!--          <div class="help-action">-->
    <!--            <v-icon-->
    <!--              icon="mdi-undo"-->
    <!--              size="small"-->
    <!--              color="success"-->
    <!--              class="me-2"-->
    <!--            />-->
    <!--            <span>{{ $t('User.Creation.Help.UndoAction') }}</span>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </v-card-text>-->
    <!--    </v-card>-->

    <!-- Error messages section -->
    <template v-if="errorMessages && errorMessages.length > 0">
      <v-alert
        type="error"
        variant="tonal"
        class="mb-4 mt-2"
        closable
        @click:close="errorMessages = []"
      >
        <div>
          {{ $t('User.Creation.Error.Title') }}
        </div>
        <template v-for="(error, index) in errorMessages" :key="index">
          <div class="error-line error-header">
            {{ errorFieldHeaderLine(error) }}
          </div>
          <div v-if="error.message" class="error-line error-detail">
            • {{ error.message }}
          </div>
          <div v-if="error.lines" class="error-line error-lines">
            • {{ error.lines }}
          </div>
        </template>
      </v-alert>
    </template>

    <!-- Success message section -->
    <v-alert
      v-if="successMessage"
      type="success"
      variant="tonal"
      class="mb-4"
      closable
      @click:close="successMessage = ''"
    >
      {{ successMessage }}
    </v-alert>

    <!-- File actions section -->
    <v-card flat class="file-actions px-3 py-3 w-100">
      <v-row class="w-100" no-gutters>
        <v-col cols="12" class="pa-0">
          <v-card flat class="file-section-card w-100">
            <div class="d-flex flex-wrap gap-2 w-100">
              <VueJsonExcel3
                :data="data"
                name="template.csv"
                type="csv"
                emit-blob
                :escape-csv="false"
                @blob="onCsvBlob($event, 'template.csv')"
              >
                <v-btn
                  variant="outlined"
                  color="primary"
                  prepend-icon="mdi-tray-arrow-down"
                  density="comfortable"
                  class="me-2"
                  @click="handleDownload"
                >
                  {{ $t('User.Creation.DownloadBlankTemplate') }}
                </v-btn>
              </VueJsonExcel3>

              <VueJsonExcel3
                :data="dataWithExample"
                name="template_with_example.csv"
                type="csv"
                emit-blob
                :escape-csv="false"
                @blob="onCsvBlob($event, 'template_with_example.csv')"
              >
                <v-btn
                  variant="outlined"
                  color="primary"
                  prepend-icon="mdi-tray-arrow-down"
                  density="comfortable"
                  @click="handleDownload"
                >
                  {{ $t('User.Creation.DownloadTemplateWithExample') }}
                </v-btn>
              </VueJsonExcel3>
              <v-btn
                variant="flat"
                color="primary"
                prepend-icon="mdi-tray-arrow-up"
                density="comfortable"
                class="ml-2"
                @click="triggerFileUpload"
              >
                {{ $t('User.Creation.UploadCSV') }}
              </v-btn>
            </div>

            <input
              ref="fileInput"
              type="file"
              accept=".csv, .xlsx"
              class="visually-hidden-input"
              @change="handleFileUpload"
            >
          </v-card>
        </v-col>
      </v-row>
    </v-card>

    <!-- Main table section -->
    <div class="table-wrapper" :class="{ 'warning-mode': isFileLoaded }">
      <!-- Example data message -->
      <div
        v-if="hasExampleData && !isFileLoaded"
        class="info-badge"
      >
        <div class="d-flex align-center">
          <v-icon
            color="info"
            class="me-2"
            icon="mdi-lightbulb-outline"
            size="small"
          />
          <span class="text-body-2">{{ $t('User.Creation.ExampleDataMessage') }}</span>
        </div>
      </div>

      <!-- Warning message for uploaded data -->
      <div
        v-if="isFileLoaded"
        class="warning-badge"
      >
        <span class="text-body-2">{{ $t('User.Creation.WarningMessage') }}</span>
      </div>

      <!-- Data table -->
      <v-card flat class="table-container">
        <v-data-table
          :headers="localizedHeaders"
          :items="tableData"
          item-value="email"
          disable-sort
          class="editable-table"
          :items-per-page="-1"
          hide-default-footer
        >
          <template #header="{ props: { headers } }">
            <thead>
              <tr>
                <th
                  v-for="header in headers"
                  :key="header.value"
                  :class="['header-cell', header.value]"
                >
                  {{ header.title }}
                </th>
              </tr>
            </thead>
          </template>
          <template #item="{ item, index }">
            <tr
              :class="{
                'editing-row': item.isEditing,
                'error-row': hasFieldError(item, 'email')
              }"
            >
              <!-- 画面内での編集不可とする -->
              <!--              <td class="edit-column">-->
              <!--                <v-btn-->
              <!--                  icon="mdi-pencil"-->
              <!--                  size="small"-->
              <!--                  variant="text"-->
              <!--                  @click="toggleEditing(item)"-->
              <!--                >-->
              <!--                  <v-icon>{{ item.isEditing ? 'mdi-content-save' : 'mdi-pencil' }}</v-icon>-->
              <!--                </v-btn>-->
              <!--                <v-btn-->
              <!--                  v-if="item.isEditing"-->
              <!--                  icon="mdi-undo"-->
              <!--                  size="small"-->
              <!--                  variant="text"-->
              <!--                  class="ms-2"-->
              <!--                  @click="restorePreviousState(item)"-->
              <!--                >-->
              <!--                  <v-icon>mdi-undo</v-icon>-->
              <!--                  <v-tooltip-->
              <!--                    activator="parent"-->
              <!--                    location="top"-->
              <!--                  >-->
              <!--                    {{ $t('User.Creation.Help.Undo') }}-->
              <!--                  </v-tooltip>-->
              <!--                </v-btn>-->
              <!--              </td>-->
              <td
                v-for="header in headers"
                :key="header.value"
                :class="[
                  header.value,
                  { 'error-cell': hasFieldError(item, header.value) }
                ]"
              >
                <div class="cell-content align-center">
                  <template v-if="header.value === 'row_index'">
                    <div class="cell-text row-number">
                      {{ index + 2 }}
                    </div>
                  </template>
                  <template v-else-if="item.isEditing">
                    <template v-if="header.value === 'roles'">
                      <v-checkbox
                        v-model="item.isAdmin"
                        density="compact"
                        hide-details
                        @update:model-value="updateRoles(item)"
                      />
                    </template>
                    <template v-else-if="header.value === 'set_auto_password' || header.value === 'allow_social_account'">
                      <v-checkbox
                        v-model="item[header.value]"
                        density="compact"
                        hide-details
                      />
                    </template>
                    <template v-else-if="header.value === 'timezone'">
                      <v-menu
                        v-model="timezoneSelectorMenu"
                        :close-on-content-click="false"
                        location="bottom"
                      >
                        <template #activator="{ props: menuProps }">
                          <v-text-field
                            :value="item[header.value]"
                            hide-details
                            density="compact"
                            variant="outlined"
                            class="edit-field"
                            readonly
                            @update:model-value="(val) => item[header.value] = val"
                            @click="menuProps.onClick"
                          />
                        </template>
                        <v-card min-width="300" max-height="400" class="timezone-selector">
                          <v-card-text class="pa-0">
                            <v-text-field
                              v-model="timezoneSearch"
                              prepend-inner-icon="mdi-magnify"
                              density="compact"
                              hide-details
                              variant="outlined"
                              class="ma-2"
                              :placeholder="$t('Search')"
                            />
                            <v-list density="compact" class="timezone-list">
                              <template v-if="!selectedRegion">
                                <!-- Region list -->
                                <v-list-item
                                  v-for="(zones, region) in timezoneList"
                                  :key="region"
                                  :title="region"
                                  @click="selectRegion(region)"
                                >
                                  <template #prepend>
                                    <v-icon>mdi-earth</v-icon>
                                  </template>
                                  <template #append>
                                    <v-chip
                                      size="x-small"
                                      color="primary"
                                      variant="flat"
                                    >
                                      {{ zones.length }}
                                    </v-chip>
                                  </template>
                                </v-list-item>
                              </template>
                              <template v-else>
                                <!-- Header with back button -->
                                <v-list-item>
                                  <v-btn
                                    variant="text"
                                    prepend-icon="mdi-arrow-left"
                                    @click="selectedRegion = null"
                                  >
                                    {{ selectedRegion }}
                                  </v-btn>
                                </v-list-item>
                                <v-divider />
                                <!-- Region timezone list -->
                                <v-list-item
                                  v-for="zone in filterTimezones(timezoneList[selectedRegion])"
                                  :key="zone"
                                  :value="zone"
                                  :title="zone"
                                  @click="selectTimezone(item, zone)"
                                >
                                  <template #prepend>
                                    <v-icon
                                      size="small"
                                      :color="item[header.value] === zone ? 'primary' : undefined"
                                    >
                                      {{ item[header.value] === zone ? 'mdi-check' : 'mdi-clock-outline' }}
                                    </v-icon>
                                  </template>
                                </v-list-item>
                              </template>
                            </v-list>
                          </v-card-text>
                        </v-card>
                      </v-menu>
                    </template>
                    <template v-else-if="(header.value === 'password') && item.set_auto_password === true">
                      <div class="cell-text">
                        {{ '' }}
                      </div>
                    </template>
                    <template v-else-if="(header.value === 'user_groups')">
                      <SelectItems
                        v-model="formData.user_groups"
                        :field-key="fieldKey('user_groups')"
                        label=""
                        get-items-api="user-groups/"
                        item-text="user_group_name"
                        item-value="id"
                      />
                    </template>
                    <template v-else>
                      <div class="text-field-wrapper">
                        <v-text-field
                          v-model="item[header.value]"
                          density="compact"
                          hide-details
                          variant="outlined"
                          class="edit-field"
                          @click="openEditDialog(item, header.value, $event)"
                        />
                        <v-btn
                          v-if="isLongContent(item[header.value])"
                          icon="mdi-pencil"
                          size="small"
                          variant="text"
                          class="edit-button"
                          @click="openEditDialog(item, header.value, $event)"
                        />
                      </div>
                    </template>
                  </template>
                  <template v-else>
                    <template v-if="header.value === 'roles'">
                      <v-checkbox
                        :model-value="isAdminRole(item.roles)"
                        density="compact"
                        hide-details
                        readonly
                        disabled
                      />
                    </template>
                    <template v-else-if="header.value === 'set_auto_password' || header.value === 'allow_social_account'">
                      <v-checkbox
                        :model-value="item[header.value]"
                        density="compact"
                        hide-details
                        readonly
                        disabled
                      />
                    </template>
                    <template v-else>
                      <div class="cell-text">
                        {{ item[header.value] || '' }}
                      </div>
                    </template>
                  </template>
                </div>
              </td>
            </tr>
          </template>
          <template #no-data>
            <v-layout justify-start class="grey--text">
              {{ $t('NoItems') }}
            </v-layout>
          </template>
        </v-data-table>
      </v-card>
    </div>
    <template #actions>
      <v-btn
        variant="text"
        @click="close"
      >
        {{ $t('Cancel') }}
      </v-btn>
      <ActionButton
        :disabled="!isFileLoaded"
        save
        @click="handleSubmit"
      />
    </template>
  </simple-card-dialog>

  <v-dialog v-model="showHelperDialog" max-width="800px" scrollable>
    <v-card>
      <v-card-title class="helper-title">
        <v-icon icon="mdi-information-outline" color="info" class="me-2" />
        {{ $t('User.Creation.Helper.Title') }}
      </v-card-title>

      <v-card-text>
        <div class="helper-section">
          <div class="section-title">
            {{ $t('User.Creation.Helper.RequiredFields') }}
          </div>
          <div class="fields-grid">
            <div class="field-item">
              <div class="field-name">
                last_name (姓), first_name (名)
              </div>
              <div class="field-name">
                last_name_en (英字 大文字), first_name_en (英字 大文字)
              </div>
              <div class="field-rules">
                {{ $t('User.Creation.Helper.NameRules') }}
              </div>
            </div>
            <div class="field-item">
              <div class="field-name">
                email (Eメールアドレス)
              </div>
              <div class="field-rules">
                {{ $t('User.Creation.Helper.EmailRules') }}
              </div>
            </div>
            <div class="field-item">
              <div class="field-name">
                language (言語)
              </div>
              <div class="field-rules">
                {{ $t('User.Creation.Helper.LanguageRules') }}
              </div>
              <div class="field-values" v-html="$t('User.Creation.Helper.SupportedLanguages.Available.List')" />
            </div>
            <div class="field-item">
              <div class="field-name">
                timezone (タイムゾーン)
              </div>
              <div class="field-rules">
                {{ $t('User.Creation.Helper.TimezoneRules') }}
              </div>
              <div class="field-values">
                {{ $t('Example') }} <code>Asia/Tokyo</code>, <code>Europe/Paris</code>
              </div>
            </div>
          </div>
        </div>

        <div class="helper-section">
          <div class="section-title">
            {{ $t('User.Creation.Helper.PasswordSection') }}
          </div>
          <div class="fields-grid">
            <div class="field-item">
              <div class="field-name">
                set_auto_password (自動パスワード)
              </div>
              <div class="field-rules">
                {{ $t('User.Creation.Helper.AutoPasswordRules') }}
              </div>
              <div class="field-values" v-html="$t('User.Creation.Helper.AutoPasswordHint')" />
              <div class="field-values" v-html="$t('User.Creation.Helper.SetPasswordHint')" />
            </div>
            <div class="field-item">
              <div class="field-name">
                password (パスワード)
              </div>
              <div class="field-rules" v-html="$t('User.Creation.Helper.PasswordRules1')" />
              <div class="field-rules" v-html="$t('User.Creation.Helper.PasswordRules2')" />
              <div class="field-examples error-examples">
                <div class="example-item">
                  <v-icon color="error" size="small">
                    mdi-close
                  </v-icon>
                  <code>123</code> {{ $t('User.Creation.Helper.PasswordError1') }}
                </div>
                <div class="example-item">
                  <v-icon color="error" size="small">
                    mdi-close
                  </v-icon>
                  <code>password123</code> {{ $t('User.Creation.Helper.PasswordError2') }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="helper-section">
          <div class="section-title">
            {{ $t('User.Creation.Helper.OptionalFields') }}
          </div>
          <div class="fields-grid">
            <div class="field-item">
              <div class="field-name">
                roles (管理者)
              </div>
              <div class="field-rules">
                {{ $t('User.Creation.Helper.RolesRules') }}
              </div>
              <div class="field-values" v-html="$t('User.Creation.Helper.RolesRulesHint1')" />
              <div class="field-values" v-html="$t('User.Creation.Helper.RolesRulesHint2')" />
            </div>
            <div class="field-item">
              <div class="field-name">
                allow_social_account (ソーシャルアカウント連携を許可)
              </div>
              <div class="field-rules">
                {{ $t('User.Creation.Helper.AllowSocialAccountRules') }}
              </div>
              <div class="field-values" v-html="$t('User.Creation.Helper.AllowSocialAccountHint1')" />
              <div class="field-values" v-html="$t('User.Creation.Helper.AllowSocialAccountHint2')" />
            </div>
          </div>
        </div>

        <!-- Section Language -->
        <div class="helper-section">
          <div class="section-title">
            <v-icon icon="mdi-translate" color="primary" class="me-2" />
            {{ $t('User.Creation.Helper.SupportedLanguages.Title') }}
          </div>
          <div class="language-grid">
            <div v-for="(code) in ['en', 'ja']" :key="code" class="language-item">
              <code>{{ code }}</code>
              <span>{{ $t(`User.Creation.Helper.SupportedLanguages.Available.Names.${code}`) }}</span>
            </div>
          </div>
        </div>

        <!-- Section Timezone -->
        <div class="helper-section">
          <div class="section-title">
            <v-icon icon="mdi-earth" color="primary" class="me-2" />
            {{ $t('User.Creation.Helper.SupportedTimezones') }}
          </div>
          <div class="timezone-grid">
            <div v-for="region in timezoneRegions" :key="region.name" class="timezone-region">
              <div class="region-name" style="cursor: pointer" @click="toggleRegion(region)">
                <v-icon
                  :icon="region.isExpanded ? 'mdi-chevron-down' : 'mdi-chevron-right'"
                  size="small"
                  class="me-2"
                />
                {{ region.name }}
                <span class="timezone-count">({{ region.zones.length }})</span>
              </div>
              <div v-show="region.isExpanded" class="timezone-list">
                <div v-for="tz in region.zones" :key="tz" class="timezone-item">
                  <code>{{ tz }}</code>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          variant="text"
          @click="showHelperDialog = false"
        >
          {{ $t('Close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!-- Add help button in the action bar -->
  <v-btn
    icon
    variant="text"
    color="info"
    class="help-button"
    @click="showHelperDialog = true"
  >
    <v-icon>mdi-help-circle-outline</v-icon>
  </v-btn>

  <!-- edit box for long content -->
  <v-dialog
    v-model="editDialog"
    :scrim="false"
    class="future-dialog"
  >
    <v-card class="future-card">
      <v-card-text class="pa-2">
        <div class="edit-container">
          <v-text-field
            v-model="editingValue"
            class="future-input"
            autofocus
            hide-details
            variant="plain"
            density="comfortable"
          />
          <v-btn
            color="primary"
            variant="text"
            class="save-button"
            @click="saveEditDialog"
          >
            {{ $t('Save') }}
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import CreateEditMixin from './CreateEditMixin'
import VueJsonExcel3 from 'vue-json-excel3'
import { saveAs } from 'file-saver'
import { userFormData } from '../../library/utils'
import { timezoneList } from '../../data/timezones'
import * as XLSX from 'xlsx'
import SelectItems from '../../components/parts/inputs/SelectItems'
import FormMixin from '../forms/FormMixin'
import Papa from 'papaparse'

const BULK_USER_ROW_LIMIT = 300

export default {
  components: {
    SelectItems,
    VueJsonExcel3
  },
  mixins: [CreateEditMixin, FormMixin],
  props: {
    selectedGroups: {
      type: Array,
      default: null
    },
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    model: false,
    api: 'users',
    formData: {},
    tableData: [
      {
        last_name: '山田',
        first_name: '太郎',
        last_name_en: 'YAMADA',
        first_name_en: 'TARO',
        email: 'yamada@example.com',
        password: '',
        set_auto_password: true,
        language: 'ja',
        timezone: 'Asia/Tokyo',
        roles: ['admin'],
        is_active: true,
        user_groups: [],
        isEditing: false,
        isAdmin: true,
        allow_social_account: false,
        social_accounts: []
      }
    ],
    previousStates: {},
    isFileLoaded: false,
    headers: [
      { value: 'row_index', title: '1' },
      { value: 'last_name', title: 'User.Fields.LastName' },
      { value: 'first_name', title: 'User.Fields.FirstName' },
      { value: 'last_name_en', title: 'User.Fields.LastNameEn' },
      { value: 'first_name_en', title: 'User.Fields.FirstNameEn' },
      { value: 'email', title: 'User.Fields.Email' },
      { value: 'password', title: 'User.Fields.Password' },
      { value: 'set_auto_password', title: 'User.Fields.AutoPassword' },
      { value: 'language', title: 'User.Fields.Language' },
      { value: 'timezone', title: 'User.Fields.Timezone' },
      { value: 'roles', title: 'User.Fields.Admin' },
      // { value: 'user_groups', title: 'User.Fields.Groups' },
      { value: 'allow_social_account', title: 'User.Fields.AllowSocialAccount' }
    ],
    rowErrors: {},
    errorMessages: [],
    data: [
      {
        last_name: '',
        first_name: '',
        last_name_en: '',
        first_name_en: '',
        email: '',
        password: '',
        set_auto_password: '',
        language: '',
        timezone: '',
        roles: '',  // should be 'admin' or empty
        // user_groups: '',
        allow_social_account: ''
      }
    ],
    dataWithExample: [
      {
        last_name: '山田',
        first_name: '太郎',
        last_name_en: 'YAMADA',
        first_name_en: 'TARO',
        email: 'example@example.com',
        password: '',
        set_auto_password: true,
        language: 'ja',
        timezone: 'Asia/Tokyo',
        roles: 'admin',
        // user_groups: '',
        allow_social_account: false
      }
    ],
    activeStep: 1,
    showHelperDialog: false,
    supportedLanguages: {
      'en': 'English',
      'ja': '日本語'
    },
    expandedRegions: new Set(),
    successMessage: '',
    editDialog: false,
    editingValue: '',
    editingItem: null,
    editingField: '',
    timezoneSelectorMenu: false,
    timezoneSearch: '',
    timezoneList,
    selectedRegion: null,
    groupListSelectorMenu: false,
    groupList: []
  }),
  computed: {
    ...mapGetters(['ui']),
    hasEditingRows() {
      return this.tableData.some(item => item.isEditing)
    },
    hasExampleData() {
      return this.tableData.some(item => this.isExampleData(item))
    },
    localizedHeaders() {
      return this.headers.map(header => ({
        ...header,
        title: this.$t(header.title)
      }))
    },
    timezoneRegions() {
      return Object.entries(timezoneList)
        .map(([name, zones]) => ({
          name,
          zones: zones.sort(),
          isExpanded: this.expandedRegions.has(name)
        }))
    }
  },
  watch: {
    formData: {
      handler: function () {
        if (this.currentData) {
          const currentUser = this.$store.getters.login
          if (this.currentData.id === currentUser.profile.id) {
            if (this.currentData.language !== this.formData.language || this.currentData.timezone !== this.formData.timezone) {
              this.browserReload = true
            } else {
              this.browserReload = false
            }
          }
        }
      },
      deep: true
    },
    modelValue: {
      handler(val) {
        this.model = val
      },
      immediate: true
    },
    model(val) {
      if (!val && this.successMessage) {
        this.successMessage = ''
      }
    }
  },
  created() {
    this.formData = userFormData()
    window.addEventListener('resize', this.handleResize)
    // user_group はここでは登録しないため
    // this.$http.get('user-groups/', { params: { limit: 1000 } }).then((res) => {
    //   this.groupList = res.data.results
    //   res.data.results.forEach((result) => {
    //     this.groupList.push(result.user_group_name)
    //   })
    // })
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    errorFieldHeaderLine(error) {
      const h = this.headers.find(item => item.value === error.field)
      if (h?.title) {
        return `${error.field} (${this.$t(h.title)}):`
      }
      return `${error.field}:`
    },
    handleResize() {
      this.$forceUpdate()
    },
    triggerFileUpload() {
      this.$refs.fileInput.value = ''  // 同じファイル名をアップロードしたとき、inputの@changeを発火させるための処理
      this.$refs.fileInput.click()
    },
    handleFileUpload(event) {
      const file = event.target?.files?.[0]

      if (!file) return

      this.errorMessages = []
      this.rowErrors = {}
      this.successMessage = ''

      const allowedExtensions = ['csv', 'xlsx']
      const fileExtension = file.name.split('.').pop()?.toLowerCase()
      if (!allowedExtensions.includes(fileExtension)) {
        alert('Only files CSV or XLSX are accepted.')
        return
      }
      const reader = new FileReader()
      reader.onload = () => {
        const ok = this.processFile(reader.result, fileExtension)
        if (ok !== false) {
          this.activeStep = 3
        }
      }
      if (fileExtension === 'csv') {
        reader.readAsText(file)
      } else if (fileExtension === 'xlsx') {
        reader.readAsBinaryString(file)
      }
    },
    processFile(content, extension) {
      if (extension === 'csv') {
        this.processCsv(content)
      } else if (extension === 'xlsx') {
        this.processXlsx(content)
      }
      this.tableData.forEach(item => {
        if (item.password === '') item.password = null
        item.user_groups = []
        item.isAdmin = this.isAdminRole(item.roles)
      })

      this.formData = this.tableData
      if (this.tableData.length > BULK_USER_ROW_LIMIT) {
        // フロント側で一旦上限を設ける
        this.errorMessages = [{
          field: this.$t('User.Creation.Error.RowLimitExceededTitle'),
          message: this.$t('User.Creation.Error.RowLimitExceeded', { limit: BULK_USER_ROW_LIMIT }),
          lines: ''
        }]
        this.isFileLoaded = false
        this.tableData = [
          {
            last_name: '山田',
            first_name: '太郎',
            last_name_en: 'YAMADA',
            first_name_en: 'TARO',
            email: 'yamada@example.com',
            password: '',
            set_auto_password: true,
            language: 'ja',
            timezone: 'Asia/Tokyo',
            roles: ['admin'],
            user_groups: [],
            is_active: true,
            isEditing: false,
            isAdmin: true,
            allow_social_account: false,
            social_accounts: []
          }
        ]

        return false
      }
      this.isFileLoaded = true
    },
    processCsv(content) {
      const { data, errors } = Papa.parse(content, {
        header: true,
        skipEmptyLines: true
      })

      if (errors.length > 0) {
        this.errorMessages = [{
          field: 'CSV',
          message: this.$t('ApiTranslate.UnknownError'),
          lines: ''
        }]
        return
      }

      this.tableData = data
        .map(row => ({
          first_name: row.first_name || '',
          first_name_en: row.first_name_en || '',
          last_name: row.last_name || '',
          last_name_en: row.last_name_en || '',
          email: row.email || '',
          password: row.password || null,
          set_auto_password: String(row.set_auto_password).toUpperCase() === 'TRUE',
          language: row.language || '',
          timezone: row.timezone || '',
          roles: row.roles ? [row.roles] : [],
          user_groups: row.user_groups ? [row.user_groups] : [],
          isEditing: false,
          isAdmin: row.roles === 'admin',
          allow_social_account: String(row.allow_social_account).toUpperCase() === 'TRUE',
          social_accounts: []
        }))
        .filter(row => row.email)

      this.isFileLoaded = true
    },
    processXlsx(content) {
      const workbook = XLSX.read(content, { type: 'binary' })
      const sheetName = workbook.SheetNames[0]
      const sheet = workbook.Sheets[sheetName]
      const data = XLSX.utils.sheet_to_json(sheet)

      this.tableData = []
      this.tableData = data.map(row => ({
        first_name: row['first_name'] || '',
        first_name_en: row['first_name_en'] || '',
        last_name: row['last_name'] || '',
        last_name_en: row['last_name_en'] || '',
        email: row['email'] || '',
        password: row['password'] || null,
        set_auto_password: row['set_auto_password']?.toString().toUpperCase() === 'TRUE',
        language: row['language'] || '',
        timezone: row['timezone'] || '',
        roles: row['roles'] ? [row['roles']] : [],
        user_groups: row['user_groups'] ? [row['user_groups']] : [],
        isEditing: false,
        isAdmin: true,
        allow_social_account: row['allow_social_account']?.toString().toUpperCase() === 'TRUE',
        social_accounts: []
      }))

      this.isFileLoaded = true
    },
    toggleEditing(item) {
      const currentEditingRow = this.tableData.find(row => row.isEditing)

      if (currentEditingRow && currentEditingRow !== item) {
        currentEditingRow.isEditing = false
        currentEditingRow.isAdmin = this.isAdminRole(currentEditingRow.roles)
      }

      const rowIndex = this.tableData.indexOf(item)

      if (!item.isEditing) {
        this.previousStates[rowIndex] = { ...item }
      }

      item.isEditing = !item.isEditing
      if (item.isEditing) {
        // Clean errors for this row
        if (this.rowErrors[`row_${rowIndex}`]) {
          delete this.rowErrors[`row_${rowIndex}`]

          // Rebuild error messages structure
          const remainingErrors = {}
          Object.keys(this.rowErrors).forEach(key => {
            if (this.rowErrors[key]?.errors) {
              remainingErrors[key] = this.rowErrors[key]
            }
          })

          // Only update errorMessages if there are remaining errors
          if (Object.keys(remainingErrors).length > 0) {
            const error = { response: { data: remainingErrors } }
            this.errorMessages = this.extractBulkUsersErrorMessage(error)
          } else {
            this.errorMessages = []
          }
        }
      } else {
        item.isAdmin = this.isAdminRole(item.roles)
      }
    },
    isExampleData(item) {
      return item.email === 'yamada@example.com' || item.email === 'example@example.com'
    },
    close() {
      this.errorMessages = [] // Clear errors on close
      // Reset data
      this.tableData = [
        {
          last_name: '山田', // Yamada
          first_name: '太郎', // Taro
          last_name_en: 'YAMADA',
          first_name_en: 'TARO',
          email: 'yamada@example.com',
          password: '',
          set_auto_password: true,
          language: 'ja',
          timezone: 'Asia/Tokyo',
          roles: ['admin'],
          user_groups: [],
          is_active: true,
          isEditing: false,
          isAdmin: true,
          allow_social_account: false,
          social_accounts: []
        }
      ]
      this.isFileLoaded = false
      this.formData = userFormData()
      this.rowErrors = {}
      this.activeStep = 1

      this.model = false
    },
    isAdminRole(roles) {
      return Array.isArray(roles) && roles.includes('admin')
    },
    updateRoles(item) {
      item.roles = item.isAdmin ? ['admin'] : []
    },
    handleDownload() {
      this.activeStep = 2
    },
    /**
     * Excel が UTF-8 として開けるよう BOM を付与して保存する（日本語の文字化け防止）
     */
    async onCsvBlob(blob, filename) {
      const bom = new Uint8Array([0xef, 0xbb, 0xbf])
      const arrayBuffer = await blob.arrayBuffer()
      const merged = new Uint8Array(bom.length + arrayBuffer.byteLength)
      merged.set(bom, 0)
      merged.set(new Uint8Array(arrayBuffer), bom.length)
      saveAs(
        new Blob([merged], { type: 'text/csv;charset=utf-8' }),
        filename
      )
    },
    toggleRegion(region) {
      if (this.expandedRegions.has(region.name)) {
        this.expandedRegions.delete(region.name)
      } else {
        this.expandedRegions.add(region.name)
      }
      this.$forceUpdate()
    },
    extractBulkUsersErrorMessage(error) {
      if (!error.response?.data) {
        return [{
          field: 'Error',
          message: this.$t('ApiTranslate.UnknownError'),
          lines: ''
        }]
      }

      const errorData = error.response.data
      const errorGroups = {}

      // Handle row-specific errors
      if (errorData.errors) {
        Object.entries(errorData.errors).forEach(([rowKey, rowData]) => {
          if (rowKey.startsWith('row_')) {
            const rowNumber = parseInt(rowKey.split('_')[1], 10) + 2
            const rowErrors = rowData.errors || {}

            Object.entries(rowErrors).forEach(([field, messages]) => {
              if (!errorGroups[field]) {
                errorGroups[field] = {}
              }

              messages.forEach(msg => {
                const translatedMessage = this.$t(msg)

                if (!errorGroups[field][translatedMessage]) {
                  errorGroups[field][translatedMessage] = []
                }

                if (!errorGroups[field][translatedMessage].includes(rowNumber)) {
                  errorGroups[field][translatedMessage].push(rowNumber)
                }
              })
            })
          }
        })
      }

      // Format errors for display
      return Object.entries(errorGroups).flatMap(([field, messageMap]) =>
        Object.entries(messageMap).map(([message, lines]) => ({
          field,
          message,
          lines: this.$t('User.Creation.Error.LinesAffected', {
            lines: [...new Set(lines)]
              .sort((a, b) => a - b)
              .join(', ')
          })
        }))
      )
    },
    hasFieldError(item, field) {
      const rowIndex = this.tableData.indexOf(item)
      const rowKey = `row_${rowIndex}`
      const rowErrors = this.rowErrors[rowKey]?.errors || {}

      return rowErrors[field]?.length > 0
    },
    handleSubmit() {
      // Reset errors
      this.errorMessages = []
      this.rowErrors = {}

      if (this.tableData.length > BULK_USER_ROW_LIMIT) {
        this.errorMessages = [{
          field: this.$t('User.Creation.Error.RowLimitExceededTitle'),
          message: this.$t('User.Creation.Error.RowLimitExceeded', { limit: BULK_USER_ROW_LIMIT }),
          lines: ''
        }]
        return
      }

      // Call mixin's submit and handle errors
      this.submit()
        .then(() => {
          this.close()
        })
        .catch(error => {
        if (error.response?.data?.errors) {
          // Store raw errors for row highlighting
          this.rowErrors = error.response.data.errors

          // Process and group errors for display
          this.errorMessages = this.extractBulkUsersErrorMessage(error)
        }
      })
    },
    isLongContent(value) {
      return value && value.length > 30
    },
    openEditDialog(item, field) {
      this.editingItem = item
      this.editingField = field
      this.editingValue = item[field]
      this.editDialog = true
    },
    saveEditDialog() {
      if (this.editingItem && this.editingField) {
        this.editingItem[this.editingField] = this.editingValue
      }
      this.editDialog = false
      this.editingItem = null
      this.editingField = ''
      this.editingValue = ''
    },
    filterTimezones(zones) {
      if (!this.timezoneSearch) return zones
      const search = this.timezoneSearch.toLowerCase()
      return zones.filter(zone => zone.toLowerCase().includes(search))
    },
    selectRegion(region) {
      this.selectedRegion = region
    },
    selectTimezone(item, timezone) {
      item.timezone = timezone
      this.timezoneSelectorMenu = false
      this.selectedRegion = null
      this.timezoneSearch = ''
    },
    selectGroupList(item, groupList) {
      item.user_groups = groupList
      this.groupListSelectorMenu = false
    },
    restorePreviousState(item) {
      const rowIndex = this.tableData.indexOf(item)
      if (this.previousStates[rowIndex]) {
        Object.assign(item, this.previousStates[rowIndex])
        item.isEditing = false
        delete this.previousStates[rowIndex]

        if (this.rowErrors[`row_${rowIndex}`]) {
          delete this.rowErrors[`row_${rowIndex}`]

          const remainingErrors = {}
          Object.keys(this.rowErrors).forEach(key => {
            if (this.rowErrors[key]?.errors) {
              remainingErrors[key] = this.rowErrors[key]
            }
          })

          if (Object.keys(remainingErrors).length > 0) {
            const error = { response: { data: remainingErrors } }
            this.errorMessages = this.extractBulkUsersErrorMessage(error)
          } else {
            this.errorMessages = []
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.table-container {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-top: 1rem;
  overflow: hidden;
}

.v-data-table {
  width: 100%;
}

.v-data-table :deep(table) {
  table-layout: auto;
  width: max-content;
  min-width: 100%;
  border-collapse: collapse;
}

.v-data-table :deep(.v-data-table__wrapper) {
  margin: 0;
  border: none;
  background-color: white;
  padding: 0 8px;
  overflow-x: auto;
}

.v-data-table :deep(thead) {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: #f8fafc;
}

.v-data-table :deep(th) {
  height: auto !important;
  background-color: #f8fafc;
  border: none;
  padding: 16px !important;
  white-space: nowrap;
  min-width: min-content;
}

.v-data-table :deep(tbody) {
  background-color: white;
}

.v-data-table :deep(tbody tr) {
  transition: background-color 0.2s ease;
  border-top: 1px solid #f1f5f9;
}

.v-data-table :deep(tbody tr:first-child) {
  border-top: none;
}

.v-data-table :deep(tbody tr:hover) {
  background-color: #f1f5f9;
}

.v-data-table :deep(td) {
  padding: 10px 16px !important;
  position: relative;
  white-space: nowrap;
  overflow: visible;
  vertical-align: top;
  min-height: 44px;
  height: auto !important;
  color: #475569;
  font-size: 0.875rem;
  min-width: min-content;
}

.v-data-table :deep(th.row_index),
.v-data-table :deep(td.row_index) {
  width: 3rem;
  max-width: 3.5rem;
  text-align: center;
  vertical-align: middle;
}

.v-data-table :deep(.row-number) {
  font-variant-numeric: tabular-nums;
}

.v-data-table :deep(td.roles .cell-content),
.v-data-table :deep(td.set_auto_password .cell-content),
.v-data-table :deep(td.allow_social_account .cell-content) {
  align-items: center;
  min-height: 32px;
}

.v-data-table :deep(td.roles),
.v-data-table :deep(td.set_auto_password),
.v-data-table :deep(td.allow_social_account) {
  white-space: nowrap;
  vertical-align: middle;
}

.v-data-table :deep(.v-checkbox) {
  margin: 0 !important;
  padding: 0 !important;
  height: 32px !important;
}

.v-data-table :deep(.v-checkbox) {
  margin: 0 !important;
  padding: 0 !important;
  height: 32px !important;
  opacity: 1;
}

.v-data-table :deep(.v-selection-control) {
  height: 32px !important;
  opacity: 1;
}

.header-cell {
  white-space: nowrap;
  min-height: 3rem;
  padding: 1rem 0.75rem !important;
  font-size: 0.875rem;
  text-align: left;
  vertical-align: middle;
  font-weight: 600;
  line-height: 1.4;
  color: #2c3e50;
  background-color: #f8fafc;
  border: none;
}

.cell-content {
  position: relative;
  display: flex;
  align-items: flex-start;
  min-height: 32px;
  width: max-content;
  min-width: 100%;
  max-width: max-content;
  white-space: nowrap;
}

.cell-text {
  white-space: nowrap;
  max-width: none;
  flex-shrink: 0;
}

.file-actions {
  background-color: rgba(0, 0, 0, 0.02);
  border-radius: 1rem;
}

.file-section-card {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  background-color: transparent;
}

.visually-hidden-input {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.table-wrapper {
  position: relative;
  margin-top: 1rem;
  background-color: rgba(var(--v-theme-info), 0.15);
  border-radius: 0.5rem;
  padding: 1rem;
  transition: background-color 0.3s ease;
}

.table-wrapper.warning-mode {
  background-color: rgba(248, 203, 0, 0.6);
}

.info-badge,
.warning-badge {
  padding: 0.5rem 0.75rem;
  border-radius: 1rem;
  background: white;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 0.875rem;
}

.info-badge {
  box-shadow: 0 0 0 1px rgba(var(--v-theme-info), 0.1);
  color: rgb(var(--v-theme-info));
}

.warning-badge {
  box-shadow: 0 0 0 1px rgba(253, 216, 53, 0.1);
  color: rgb(var(--v-theme-warning));
}

.info-badge .text-body-2,
.warning-badge .text-body-2 {
  line-height: 1.2;
  white-space: nowrap;
}

.instructions-card {
  border: 1px solid rgba(var(--v-theme-info), 0.2);
  background-color: rgba(var(--v-theme-info), 0.05) !important;
}

.steps-container {
  display: flex;
  align-items: flex-start;
  gap: 24px;
  padding: 16px 0;
}

.step {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  flex: 1;
  opacity: 0.7;
  transition: opacity 0.3s ease;
}

.step.active {
  opacity: 1;
}

.step-number {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: rgb(var(--v-theme-info));
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  flex-shrink: 0;
}

.step-content {
  flex: 1;
}

.step-title {
  font-weight: 600;
  margin-bottom: 4px;
  color: rgb(var(--v-theme-info));
}

.step-description {
  font-size: 0.875rem;
  color: rgba(var(--v-theme-on-surface), 0.7);
}

.step-divider {
  margin: 0 8px;
  height: auto;
  align-self: stretch;
}

.error-row {
  background-color: rgba(var(--v-theme-error), 0.02);
}

.error-line {
  padding: 4px 10px;
  line-height: 1.5;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.error-header {
  font-weight: 500;
  color: rgb(var(--v-theme-error));
}

.error-detail,
.error-lines {
  padding-left: 24px;
  color: rgba(var(--v-theme-error), 0.75);
}

:deep(.error-cell),
:deep(td.error-cell) {
  background-color: rgba(var(--v-theme-error), 0.1) !important;
  color: rgb(var(--v-theme-error)) !important;
}

:deep(td.error-cell *) {
  color: rgb(var(--v-theme-error)) !important;
}

.helper-prompt {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-top: 8px;
  border-top: 1px solid rgba(var(--v-theme-info), 0.2);
}

.helper-text {
  color: rgba(var(--v-theme-on-surface), 0.7);
  font-size: 0.875rem;
}

.helper-button {
  flex-shrink: 0;
}

.helper-title {
  background-color: rgba(var(--v-theme-info), 0.1);
  color: rgb(var(--v-theme-info));
  padding: 16px;
}

.helper-section {
  margin-bottom: 24px;
}

.section-title {
  font-weight: 600;
  font-size: 1.1rem;
  margin-bottom: 16px;
  color: rgb(var(--v-theme-primary));
}

.fields-grid {
  display: grid;
  gap: 16px;
}

.field-item {
  background-color: rgba(var(--v-theme-surface-variant), 0.1);
  padding: 12px;
  border-radius: 8px;
}

.field-name {
  font-family: monospace;
  font-weight: 600;
  margin-bottom: 4px;
  color: rgb(var(--v-theme-primary));
}

.field-rules {
  font-size: 0.875rem;
  color: rgba(var(--v-theme-on-surface), 0.87);
}

.field-rules :deep(code) {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', monospace;
  font-size: 0.85em;
  background-color: rgba(var(--v-theme-on-surface), 0.08);
  color: rgba(var(--v-theme-on-surface), 0.87);
  padding: 2px 6px;
  border-radius: 4px;
}

.field-values {
  margin-top: 4px;
  font-family: monospace;
  font-size: 0.875rem;
  color: rgb(var(--v-theme-primary));
}

.field-values :deep(code) {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', monospace;
  font-size: 0.85em;
  background-color: rgba(var(--v-theme-primary), 0.08);
  color: rgba(var(--v-theme-primary), 0.87);
  padding: 2px 6px;
  border-radius: 4px;
}

.field-examples {
  margin-top: 8px;
}

.example-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.875rem;
  margin-top: 4px;
}

.error-examples code {
  color: rgb(var(--v-theme-error));
  background-color: rgba(var(--v-theme-error), 0.1);
  padding: 2px 6px;
  border-radius: 4px;
}

.language-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 12px;
  margin-top: 12px;
}

.language-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px;
  background-color: rgba(var(--v-theme-surface-variant), 0.1);
  border-radius: 4px;
}

.language-item code {
  background-color: rgba(var(--v-theme-primary), 0.1);
  color: rgb(var(--v-theme-primary));
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 0.875rem;
}

.timezone-grid {
  display: grid;
  gap: 1.5rem;
  margin-top: 0.75rem;
  max-height: 50vh;
  overflow-y: auto;
}

.timezone-region {
  background-color: rgba(var(--v-theme-surface-variant), 0.1);
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 0.5rem;
}

.region-name {
  font-weight: 600;
  color: rgb(var(--v-theme-primary));
  padding: 8px 0;
  display: flex;
  align-items: center;
  user-select: none;
}

.region-name:hover {
  background-color: rgba(var(--v-theme-primary), 0.05);
}

.timezone-count {
  margin-left: 0.5rem;
  color: rgba(var(--v-theme-on-surface), 0.6);
  font-size: 0.875rem;
}

.timezone-list {
  margin-top: 0.5rem;
  gap: 0.5rem;
  padding-left: 1.5rem;
}

.timezone-item {
  font-size: 0.875rem;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
}

.timezone-item:hover {
  background-color: rgba(var(--v-theme-primary), 0.05);
}

.timezone-item code {
  color: rgb(var(--v-theme-secondary));
}

.timezone-grid::-webkit-scrollbar {
  width: 0.5rem;
}

.timezone-grid::-webkit-scrollbar-track {
  background: rgba(var(--v-theme-surface-variant), 0.1);
  border-radius: 4px;
}

.timezone-grid::-webkit-scrollbar-thumb {
  background: rgba(var(--v-theme-primary), 0.2);
  border-radius: 4px;
}

.timezone-grid::-webkit-scrollbar-thumb:hover {
  background: rgba(var(--v-theme-primary), 0.3);
}
</style>
